var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 0.25C10.8096 0.25 10.25 0.809645 10.25 1.5V18.25H7.75V8.5C7.75 7.80964 7.19036 7.25 6.5 7.25H3.5C2.80964 7.25 2.25 7.80964 2.25 8.5V18.25H1C0.585786 18.25 0.25 18.5858 0.25 19C0.25 19.4142 0.585786 19.75 1 19.75H17C17.4142 19.75 17.75 19.4142 17.75 19C17.75 18.5858 17.4142 18.25 17 18.25H15.75V1.5C15.75 0.809644 15.1904 0.25 14.5 0.25H11.5ZM11.75 18.25V1.75H14.25V18.25H11.75ZM3.75 8.75V18.25H6.25V8.75H3.75Z",
    fill: "#0C333B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.3a92df2b01c91e3be9d0f03df8476902.svg";
export { ForwardRef as ReactComponent };